import { DatasheetGetDto } from '@common/dto/datasheet/get-dto';
import * as React from 'react';

type Props = {
  datasheet: DatasheetGetDto;
  onDatasheetChange: (datasheet: DatasheetGetDto) => void;
};

export const useTabsController = (props: Props) => {
  const { onDatasheetChange, datasheet } = props;

  const handleTabOrderChange = React.useCallback((tabs: DatasheetGetDto['tabs']) => {
    onDatasheetChange({
      ...datasheet,
      tabs 
    });
  }, [datasheet, onDatasheetChange]);

  return {
    handleTabOrderChange
  };
};